window.dataLayer = window.dataLayer || [];
import { pushToDataLayer } from '@/js/analytics/analytics.methods';

const gaPrefix = document.querySelector('.js-pagination-name-ga')?.dataset?.gaFilterPrefix;
const links = [...document.querySelectorAll('.js-pagination-ga a')];

function bindEventListener(el) {
  el.addEventListener('click', () =>
    pushToDataLayer({
      event: `${gaPrefix}_pagination`,
      link_text: el.textContent.trim(),
    }),
  );
}

function init() {
  if (!gaPrefix || !links.length) {
    return;
  }

  links.forEach(bindEventListener);
}

export default init;
